module.exports = __webpack_public_path__ + "img/instagram-logo.00e94833.svg";